<app-logo-area [breadcrumbs]="this.breadcrumbs()"></app-logo-area>


<main>
  <app-headline-section [title]="folder()?.name"></app-headline-section>

  @if (!refreshing()) {
    @if (folder()) {
      @switch (view()) {
        @case ('listing') {
          <app-folder-listing [folder]="folder"></app-folder-listing>
        }
        @case ('asset') {
          <app-folder-asset-view [folder]=folder()></app-folder-asset-view>
        }
      }
    }
    @if (allowPoSubmit()) {
      <section class="cl-section">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2>Encode &amp; deliver</h2>
              <p>Submit your source video content for encoding and delivery. Select a workflow type below, add your content items, and the platform will process each one into an adaptive streaming format - delivering it to your chosen destination, ready to stream on demand.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="cl-section-alternate">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <app-cl-tabs rememberAs="workflow">
                @if (
                  ('contentplatform:workflow:Mutation/StartWorkflowDefault'|isAllowed:'contentplatform:asset:input.content_identifier/s3://' + assetpath() + '/': organization()) &&
                  !isDisplayInteractive()
                ) {
                  <app-cl-tab tab_title="IFE Workflow" key="above_default" (activated)="this.poMetaService.setActive('above_default')">
                    <app-default-po></app-default-po>
                  </app-cl-tab>
                }
                @if (
                  ('contentplatform:workflow:Mutation/StartWorkflowVodDefault'|isAllowed:'contentplatform:asset:input.input_brefix/' + assetpath() + '/': organization()) &&
                  !isDisplayInteractive()
                ) {
                  <app-cl-tab tab_title="VOD Default" key="vod_default" (activated)="this.poMetaService.setActive('vod_default')">
                    <app-vod-default-po></app-vod-default-po>
                  </app-cl-tab>
                }
                @if (
                  isDisplayInteractive()
                  || organization()?.legacy_name === 'castlabs_cpteam'
                ) {
                  <app-cl-tab tab_title="VOD Display Interactive" key="vod_display_interactive" (activated)="this.poMetaService.setActive('vod_display_interactive')">
                    <app-vod-display-interactive-po></app-vod-display-interactive-po>
                  </app-cl-tab>
                }
                @if (
                  isDisplayInteractive()
                  || organization()?.legacy_name === 'castlabs_cpteam'
                ) {
                  <app-cl-tab tab_title="VOD Repackaging" key="vod_repackaging" (activated)="this.poMetaService.setActive('vod_repackaging')">
                    <app-vod-repackaging-po></app-vod-repackaging-po>
                  </app-cl-tab>
                }
                @if (
                  ('singleframewatermarking:Demo' | isAllowedAnywhere: organization()) &&
                  ('contentplatform:workflow:Mutation/StartWorkflowVodDefault'|isAllowed:'contentplatform:asset:input.input_brefix/' + assetpath() + '/': organization()) &&
                  !isDisplayInteractive()
                ) {
                  <app-cl-tab tab_title="STARDUSTmark" key="vod_passthrough_sffw" (activated)="this.poMetaService.setActive('vod_passthrough_sffw')">
                    <app-vod-passthrough-po></app-vod-passthrough-po>
                  </app-cl-tab>
                }
              </app-cl-tabs>
            </div>
          </div>
        </div>
      </section>
    }
  } @else {
    <section class="cl-section cl-section-regular">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <table class="cl-table-data">
              <thead>
                <tr>
                  <th class="cl-table-head"></th>
                  <th class="cl-table-head">Filename</th>
                  <th class="cl-table-head">Last Modified</th>
                </tr>
              </thead>
              <tbody>
                <tr appLoadRow [state]="loadState()" thing="this directory"></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  }
</main>

